/* eslint-disable prettier/prettier */

import Config from '../Config/Config';

import { CasinoTypes } from './CasinoTypes';

export const isSocialCasino = function (): boolean {
    return Config.get('casino.type') === CasinoTypes.social;
};

export const isNormalCasino = function (): boolean {
    return Config.get('casino.type') === CasinoTypes.normal;
};

